import {
  CouponCustomerLimitType,
  CouponDateType,
} from 'domains/Marketing/Coupons/components/CouponForm/types';
import {
  buildUrl,
  DATE_TYPE_QUERY_PARAM,
  DISCOUNT_OPTION_ID_QUERY_PARAM,
  MARKETING_ROUTES,
} from '../marketingRoutes';

export const UNIQUE_CODE = 'The code must be unique.';

export const CUSTOMER_LIMIT_TYPE_QUERY_PARAM = 'customer_limit_type';

interface CouponUrlParams {
  dateType?: CouponDateType;
  customerLimitType?: CouponCustomerLimitType;
  discountOptionId?: string;
}

export const buildNewCouponUrl = ({
  dateType,
  customerLimitType,
  discountOptionId,
}: CouponUrlParams): string =>
  buildUrl(MARKETING_ROUTES.newCoupon, {
    [DATE_TYPE_QUERY_PARAM]: dateType,
    [CUSTOMER_LIMIT_TYPE_QUERY_PARAM]: customerLimitType,
    [DISCOUNT_OPTION_ID_QUERY_PARAM]: discountOptionId,
  });
